// BlueMouse GmbH Helpers
import errorsHandler from './helpers/errors.js';
import initSelect2 from './helpers/select2.js';
import initAutosize from './helpers/autosize.js';
import initBootstrapTable from './helpers/bootstrapTable.js';
import initDatepicker from './helpers/datepicker.js';
import initEditableSelect2 from './helpers/editableSelect2.js';
import * as tooltip from './helpers/tooltip.js';
import {
	addNewPrototype,
	initDeleteBtn,
	initForms,
	dateHandler,
	exportExcelHandler,
	modalAjaxForm,
	formatNumber,
	bmRoundPrice,
	reverseFormat,
	addressHandler,
	getAddressInfo,
	filterHandler,
	calcTotal,
	productPrototypeHandler,
	formWithTabs,
	initFormatPhoneNumber,
	updateOptionsSelect2,
	getPrrcInfo,
	getUserInfo,
	removePrototype
} from './helpers/helper.js';
import initLogPage from './pages/logPage.js';
import initCapaReportForm from './forms/capaReport.js';
import initChangeControlForm from './forms/changeControl.js';
import initExternalTrainingForm from './forms/externalTraining.js';
import initInternalReportForm from './forms/internalReport.js';
import initInternalTrainingForm from './forms/internalTraining.js';
import initSupplierComplaintForm from './forms/supplierComplaint.js';
import initAfterSalesReportForm from './forms/afterSales.js';

$( document ).ready(function() {
	// Show errors as alert
	errorsHandler();

	// Init all functions
	initSelect2();
	initAutosize();
	initBootstrapTable();
	initDatepicker();
	initDeleteBtn();
	initForms();
	initFormatPhoneNumber();
	exportExcelHandler();
	filterHandler();

	//Initialize all tooltip for the input fields
	if($('[data-function="tooltip-input"]').length){
		tooltip.init('[data-function="tooltip-input"]');
	}

	// Removes the after-loaded class, usually used in the css file to activate the animation effects
	$('.after-loaded').removeClass('after-loaded');


	if($('#address-add-edit-container').length){
		addEditAddressHandler();
	}

	if($('#product-add-edit-container').length){
		addEditProductHandler();
	}

	if($('#offer-add-edit-container').length){
		addEditOfferHandler();
	}

	if($('#order-add-edit-container').length){
		addEditOrderHandler();
	}

	if($('#return-order-add-edit-container').length){
		addEditReturnHandler();
	}

	if($('#invoice-add-edit-container').length){
		addEditInvoiceHandler();
	}

	if($('#supplier-add-edit-container').length){
		addEditSupplierHandler();
	}

	if($('#legal-manufacturer-add-edit-container').length){
		addEditSupplierHandler();
	}

	if($('#statistic-list-container').length){
		indexStatisticHandler();
	}

	if($('#log-list-container').length){
		indexLogHandler();
	}

	if($('#activity-log-index-container').length){
		indexActivityHandler();
	}

	if($('#activity-list-container').length){
		indexLogActivityHandler();
	}

	if($('#user-add-edit-container').length){
		addEditUserHandler();
	}

	if($('#demo-product-add-edit-container').length){
		addEditDemoProductHandler();
	}

	if($('#demo-products-log-container').length){
		dateHandler();
	}

	if($('#report-add-edit-container').length){
		addEditReportHandler();
	}

	if($('#capa-report-add-edit-container').length){
		initCapaReportForm();
	}
	if($('#change-control-add-edit-container').length){
		initChangeControlForm();
	}
	if($('#external-training-add-edit-container').length){
		initExternalTrainingForm();
	}
	if($('#internal-training-add-edit-container').length){
		initInternalTrainingForm();
	}
	if($('#internal-report-add-edit-container').length){
		initInternalReportForm();
	}
	if($('#supplier-complaint-add-edit-container').length){
		initSupplierComplaintForm();
	}
	if($('#after-sales-add-edit-container').length){
		initAfterSalesReportForm();
	}
	initEditableSelect2();

    if($('.price-type-filter').length){
        addPriceTypeFilterHandler();
    }
});

function addPriceTypeFilterHandler()
{
    $('.price-type-filter').on('change', function(){
        if(!['without_vat', 'vat'].includes($(this).val())) {
            $('.invoice-date-type-filter').addClass('d-none');
        } else {
            $('.invoice-date-type-filter').removeClass('d-none');
        }
    })
}

function addEditAddressHandler(){
	// Save the current tab so that it opens again when saving
	formWithTabs(() => {
		autosize.update($('.autosize'));

		if($('[role="tab"].active').prop('id') == 'address-info-tab'){
			$('.address-delete-btn').show();
		}else{
			$('.address-delete-btn').hide();
		}
	});
	if($('[role="tab"].active').prop('id') == 'address-info-tab'){
		$('.address-delete-btn').show();
	}else{
		$('.address-delete-btn').hide();
	}


	/**** Project Tab *****/
	// Hide or show the closed at field in the project view
	const projectsCloseHandler = () =>{
		$('[data-function="projects-close-handler"]').unbind('change.projects-close-handler').bind('change.projects-close-handler', function(){
			if($(this).is(':checked')){
				$(this).parents('.row').eq(0).find('[data-id="closed_at"]').parents('.form-group').eq(0).removeClass('d-none');
			}else{
				$(this).parents('.row').eq(0).find('[data-id="closed_at"]').parents('.form-group').eq(0).addClass('d-none');
			}
		});
	}
	projectsCloseHandler();
	// Create a new project row on button click
	addNewPrototype('add-new-prototype-project', () => {
		initDatepicker();
		initAutosize();
		projectsCloseHandler();
	});
	/**** END Project Tab *****/


	// Copy the address data in the delivery box
	$('[data-function="copy-address-info-to-delivery"]').unbind('click.copy-address-info-to-delivery').bind('click.copy-address-info-to-delivery', function(){
		const company = $('#company').val();
		const address_2 = $('#address_2').val();
		const address_3 = $('#address_3').val();
		const street = $('#street').val();
		const zip = $('#zip').val();
		const city = $('#city').val();

		if(
			$('#delivery_address_company').val()
			|| $('#delivery_address_address_2').val()
			|| $('#delivery_address_address_3').val()
			|| $('#delivery_address_street').val()
			|| $('#delivery_address_zip').val()
			|| $('#delivery_address_city').val()){

			$('#modal-confirm-copy').modal();

			$('[data-function="confirm-copy"]').unbind('click.confirm-copy').bind('click.confirm-copy', function(){
				$('#modal-confirm-copy').modal('hide');

				$('#delivery_address_company').val(company);
				$('#delivery_address_address_2').val(address_2);
				$('#delivery_address_address_3').val(address_3);
				$('#delivery_address_street').val(street);
				$('#delivery_address_zip').val(zip);
				$('#delivery_address_city').val(city);
			});
		}else{
			$('#delivery_address_company').val(company);
			$('#delivery_address_address_2').val(address_2);
			$('#delivery_address_address_3').val(address_3);
			$('#delivery_address_street').val(street);
			$('#delivery_address_zip').val(zip);
			$('#delivery_address_city').val(city);
		}
	});

	// Copy the address data in the invoice box
	$('[data-function="copy-address-info-to-invoice"]').unbind('click.copy-address-info-to-invoice').bind('click.copy-address-info-to-invoice', function(){
		const company = $('#company').val();
		const address_2 = $('#address_2').val();
		const address_3 = $('#address_3').val();
		const street = $('#street').val();
		const zip = $('#zip').val();
		const city = $('#city').val();

		if(
			$('#invoice_address_company').val()
			|| $('#invoice_address_address_2').val()
			|| $('#invoice_address_address_3').val()
			|| $('#invoice_address_street').val()
			|| $('#invoice_address_zip').val()
			|| $('#invoice_address_city').val()){

			$('#modal-confirm-copy').modal();

			$('[data-function="confirm-copy"]').unbind('click.confirm-copy').bind('click.confirm-copy', function(){
				$('#modal-confirm-copy').modal('hide');

				$('#invoice_address_company').val(company);
				$('#invoice_address_address_2').val(address_2);
				$('#invoice_address_address_3').val(address_3);
				$('#invoice_address_street').val(street);
				$('#invoice_address_zip').val(zip);
				$('#invoice_address_city').val(city);
			});
		}else{
			$('#invoice_address_company').val(company);
			$('#invoice_address_address_2').val(address_2);
			$('#invoice_address_address_3').val(address_3);
			$('#invoice_address_street').val(street);
			$('#invoice_address_zip').val(zip);
			$('#invoice_address_city').val(city);
		}
	});

	// Change icon when clicking on the collapse btn
	$('#shipping-method-container').on('hidden.bs.collapse', function () {
		let id = $(this).attr('id');
		$(`[href="#${id}"]`).removeClass('btn-minus');
		$(`[href="#${id}"]`).addClass('btn-plus');
	});
	$('#shipping-method-container').on('shown.bs.collapse', function () {
		let id = $(this).attr('id');
		$(`[href="#${id}"]`).removeClass('btn-plus');
		$(`[href="#${id}"]`).addClass('btn-minus');
	});


	/**** Contact Tab *****/
	// add a new contact
	$('[data-function="add-contact"]').unbind('click.add-contact').bind('click.add-contact', function(){
		$(`#add-edit-contact input, #add-edit-contact select, #add-edit-contact textarea`).not('[type="checkbox"]').val('');
		$('#add-edit-contact [type="checkbox"]').prop("checked", false);
		$('#add-edit-contact [name="contact[contact_salutation_id]"]').val(1)

		$('#add-edit-contact [data-function="delete-record"]').addClass('d-none');

		$('#add-edit-contact').removeClass('d-none');
		$('#contacts-list').addClass('d-none');
	});

	// Edit a contact
	const editContacts = () => {
		$('[data-function="edit-contact"]').unbind('click.edit-contact').bind('click.edit-contact', function(){
			const contact = JSON.parse(atob($(this).parents('tr').data('contact')));

			Object.keys(contact).forEach(key => {
				const field = $(`#add-edit-contact [name="contact[contact_${key}]"]`);

				if(field.length){
					if(field.attr('type') == 'checkbox'){
						if(contact[key]){
							field.prop("checked", true);
						}
					}else if(field.attr('type') == 'email' || field.attr('type') == 'tel'){
						let aField = field.next().find('a');
						if(aField.length){
							let oldHref = aField.attr('href');

							if(oldHref.includes('mailto:')){
								aField.attr('href', 'mailto:' + contact[key]);
							}else if(oldHref.includes('tel:')){
								aField.attr('href', 'tel:' + contact[key]);
							}
						}

						field.val(contact[key]);
					}else{
						field.val(contact[key]);
					}
				}
			});

			$('#add-edit-contact [data-function="delete-record"]').data('url', `/api/address/contact/${contact.id}/delete-warnings`);
			$('#add-edit-contact [data-function="delete-record"]').removeClass('d-none');


			$('#add-edit-contact').removeClass('d-none');
			$('#contacts-list').addClass('d-none');

			autosize.update($('.autosize'));
		});
	}
	editContacts();
	$('#contacts-list .bootstrap-table').on('post-body.bs.table', function() {
		editContacts();
	});

	// Go back to contact list
	$('[data-function="back-to-contact-list"]').unbind('click.back-to-contact-list').bind('click.back-to-contact-list', function(){
		$('#add-edit-contact').addClass('d-none');
		$('#contacts-list').removeClass('d-none');

		$(`#add-edit-contact input, #add-edit-contact select, #add-edit-contact textarea`).not('[type="checkbox"]').val('');
		$('#add-edit-contact [type="checkbox"]').prop("checked", false);
		$('#add-edit-contact [name="contact[contact_salutation_id]"]').val(1)
	});
	/**** END Contact Tab *****/


	/**** Activity Tab *****/
	// add a new activity
	$('[data-function="add-activity"]').unbind('click.add-activity').bind('click.add-activity', function(){
		$(`#add-edit-activity input, #add-edit-activity select, #add-edit-activity textarea`).not('[type="checkbox"]').val('');

		$(`#add-edit-activity [name="activities[user_id]"]`).val(window.userId);
		$(`#add-edit-activity [name="activities[date]"]`).val(moment().format('DD.MM.YYYY'));

		$('#add-edit-activity [data-function="delete-record"]').addClass('d-none');

		$('#add-edit-activity').removeClass('d-none');
		$('#activities-list').addClass('d-none');
	});

	// Edit a activity
	const editActivities = () => {
		$('[data-function="edit-activity"]').unbind('click.edit-activity').bind('click.edit-activity', function(){
			const activity = JSON.parse(atob($(this).parents('tr').data('activity')));

			Object.keys(activity).forEach(key => {
				const field = $(`#add-edit-activity [name="activities[${key}]"]`);

				if(field.length){
					let value = activity[key];

					if(key == 'date'){
						value = moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY');
					}

					field.val(value);
				}
			});

			$('#add-edit-activity [data-function="delete-record"]').data('url', `/api/address/activity/${activity.id}/delete-warnings`);
			$('#add-edit-activity [data-function="delete-record"]').removeClass('d-none');


			$('#add-edit-activity').removeClass('d-none');
			$('#activities-list').addClass('d-none');

			autosize.update($('.autosize'));
		});
	}
	editActivities();
	$('#activities-list .bootstrap-table').on('post-body.bs.table', function() {
		editActivities();
	});

	// Go back to activity list
	$('[data-function="back-to-activities-list"]').unbind('click.back-to-activities-list').bind('click.back-to-activities-list', function(){
		$('#add-edit-activity').addClass('d-none');
		$('#activities-list').removeClass('d-none');

		$(`#add-edit-activity input, #add-edit-activity select, #add-edit-activity textarea`).not('[type="checkbox"]').val('');
	});
	/**** END Activity Tab *****/
}

function addEditProductHandler(){
	// Save the current tab so that it opens again when saving
	formWithTabs();

	// Show or hide the medical products inputs
	$('[data-function="medical-product-handler"]').unbind('change.medical-product-handler').bind('change.medical-product-handler', function(){
		if($(this).is(':checked')){
			$('[data-id="medical-product-detail-form"]').removeClass('d-none');
		}else{
			$('[data-id="medical-product-detail-form"]').addClass('d-none');
		}
	});

	// Show or hide the implant_id input
	$('[data-function="implant-handler"]').unbind('change.implant-handler').bind('change.implant-handler', function(){
		if($(this).val() == 'yes'){
			$('[data-id="implant-id"]').removeClass('d-none');
		}else{
			$('[data-id="implant-id"]').addClass('d-none');
		}
	});

	// Show or hide the expiring inputs
	$('[data-function="exp-handler"]').unbind('change.exp-handler').bind('change.exp-handler', function(){
		if($(this).is(':checked')){
			$('[data-id="exp-detail-form"]').removeClass('d-none');
		}else{
			$('[data-id="exp-detail-form"]').addClass('d-none');
		}
	});

	// Show or hide the expiring inputs
	$('[data-function="maintenance-handler"]').unbind('change.maintenance-handler').bind('change.maintenance-handler', function(){
		if($(this).is(':checked')){
			$('[data-id="maintenance-detail-form"]').removeClass('d-none');
		}else{
			$('[data-id="maintenance-detail-form"]').addClass('d-none');
		}
	});

	// When uploading an image, it shows it as a preview and fills the hidden field with the value
	$('[data-function="upload-image-handler"]').unbind('change.upload-image-handler').bind('change.upload-image-handler', function(){
		// Set the hidden field as true, so we know that an image was uploaded (image is saved in a session)
		$('#uploadImageData').val(1);

		// Show the image as a preview when uploaded
		if (this.files && this.files[0]) {
			var reader = new FileReader();

			reader.onload = function(e) {
				$('.image-preview-container').find('img').remove();
				$('.image-preview-container').prepend('<img class="img-fluid mb-4" src="'+e.target.result+'" alt="" />');


				$('.image-container').remove();
				$('.image-preview-container').removeClass('d-none');
			}

			// convert to base64 string
			reader.readAsDataURL(this.files[0]);
		}
	});

	// Manage the remove preview image button
	$('[data-function="remove-preview-image"]').unbind('click.remove-preview-image').bind('click.remove-preview-image', function(){
		// Set the hidden field as false, so we know that the uploaded image (saved in the session) has not to be uploaded
		$('#uploadImageData').val(0);

		$('.image-preview-container').addClass('d-none');
		$('.image-preview-container').find('img').remove();
	});

	// Set the delete image modal as ajax
	modalAjaxForm(
		$('#modal-delete-image'),
		(data) => {
			if(data.success){
				$('.image-container').remove();
				$('.image-upload-field-container').removeClass('d-none');
				toastr.success('Bild wurde entfernt.');
			}else{
				toastr.error('Bild wurde nicht entfernt.');
			}
		}
	);

	// Calc the landed price
	$('[data-function="calc-landed-price"]').unbind('change.calc-landed-price').bind('change.calc-landed-price', function(){
		let currency = $('#purchase_currency').val();
		let price = $('#purchase_price').val();

		let val = reverseFormat(price);
        if(currency != 'chf'){
        	val = val * 1.1;
        }

		$('#landed_price').val(formatNumber(val));
		$('#landed_price').trigger('change');
	});

	// Calc the margin
	$('[data-function="calc-margin"]').unbind('change.calc-margin').bind('change.calc-margin', function(){
		let tarifPrice = reverseFormat($('#tarif_price').val());
		let landedPrice = reverseFormat($('#landed_price').val());

		let margin = ((tarifPrice - landedPrice) / tarifPrice) * 100;
		$('#margin').val(formatNumber(margin));
	});

	// Calc the tarif price
	$('[data-function="calc-tarif-price"]').unbind('change.calc-tarif-price').bind('change.calc-tarif-price', function(){
		let margin = reverseFormat($(this).val());
		let landedPrice = reverseFormat($('#landed_price').val());

		let tarifPrice = landedPrice / (1 - (margin / 100));
		$('#tarif_price').val(formatNumber(tarifPrice));
	});


	// Disable or enalbe the date field when changing the select box (CE, DC, ISO)
	$('[data-function="enable-disable-date-field"]').unbind('change.enable-disable-date-field').bind('change.enable-disable-date-field', function(){
		let target = $(this).data('target');

		if($(this).val() == 'date'){
			$(target).removeAttr('disabled');
		}else{
			$(target).attr('disabled', true);
		}
	});
}

function indexStatisticHandler(){
	dateHandler();
}

function indexLogHandler(){
	initLogPage();
}

function indexLogActivityHandler(){
	dateHandler();
}

function indexActivityHandler(){
	dateHandler();
}

function addEditOfferHandler(reload = true){
	if(reload){
		tooltip.init('[data-function="tooltip-handler"]');

		// Init the CKEditor
		ClassicEditor.create(document.querySelector('.ckeditor'),  {
	        toolbar: ['bold', 'italic', 'bulletedList', 'numberedList']
    	});
    	let editor2;
		ClassicEditor.create(document.querySelector('.ckeditor-2'),  {
	        toolbar: ['bold', 'italic', 'bulletedList', 'numberedList']
    	}).then( newEditor => {
	    	editor2 = newEditor;
	    });

		// callback function when changing the address
		const addressChangeCallback = () => {
			editor2.setData($('#text').data(pageVar.address.language));
		}

		// Handler of the address select
		addressHandler(addressChangeCallback);

		//Set the E-Mail Modal as an ajax form
		modalAjaxForm(
			$('#modal-send-email'),
			(data) => {
				if(data.success){
					toastr.success('Die E-Mail wurde gesendet.');
				}else{
					toastr.error('Die E-Mail wurde nicht gesendet.');
				}
			}
		);

		// Create a new product row on button click
		addNewPrototype('add-new-prototype-product', () => addEditOfferHandler(false), () => calcTotal());
		// Create a new position row on button click
		addNewPrototype('add-new-prototype-position', () => addEditOfferHandler(false), () => calcTotal());

    	// add 3 months to the due date when the date is changed
    	$('[data-function="update-due-date"]').change(function(){
    		let date = moment($(this).val(), 'DD.MM.YYYY');

    		if(date.isValid()){
    			date.add(1, 'M');

    			$('[data-id="due_date"]').val(date.format('DD.MM.YYYY'));
    		}

    	});


		// Make the position list sortable
	    Sortable.create(sortable, {
	    	animation: 150,
	    	ghostClass: 'bg-info',
	    	handle: '.handle'
		});


		// Make the position list sortable
	    Sortable.create(sortable2, {
	    	animation: 150,
	    	ghostClass: 'bg-info',
	    	handle: '.handle'
		});
	}

	initSelect2();
	initAutosize();


	//Calc the price of the offert
	$('[data-function="amount-handler"], [data-function="amount-position-handler"]').unbind('keyup.amount-handler').bind('keyup.amount-handler', function(){
		calcTotal();
	});

	productPrototypeHandler();

	if(reload){
		calcTotal();
	}
}

function addEditOrderHandler(reload = true){
	if(reload){
		tooltip.init('[data-function="tooltip-handler"]');

		// callback function when changing the address
		const addressChangeCallback = () => {
			$('[data-id="delivery_name"]').val(pageVar.address.delivery_info.company);
			$('[data-id="delivery_name_2"]').val(pageVar.address.delivery_info.address_2);
			$('[data-id="delivery_name_3"]').val(pageVar.address.delivery_info.address_3);
			$('[data-id="delivery_street"]').val(pageVar.address.delivery_info.street);
			$('[data-id="delivery_city"]').val(pageVar.address.delivery_info.city);
			$('[data-id="delivery_zip"]').val(pageVar.address.delivery_info.zip);
			$('[data-id="delivery_country_code"]').val(pageVar.address.delivery_info.country_code);
			$('[data-id="delivery_phone"]').val(pageVar.address.delivery_info.phone);
			$('[data-id="delivery_email"]').val(pageVar.address.delivery_info.email);
			$('[data-id="order_confirmation_mail_sent"]').prop("checked", pageVar.address.send_order_confirmation_mail);
		}

		addressHandler(addressChangeCallback);


		// Show a warning if the customer order number already exists
		$('[data-function="customer-order-nr-handler"]').unbind('change.customer-order-nr-handler').bind('change.customer-order-nr-handler', function(){
			const customerOrderNr = btoa($(this).val());

			let url = `/api/order/check-customer-order-number/${customerOrderNr}`;
			axios.get(url)
				.then(function (response) {
					let data = response.data;

					if(data.success){
						$('#modal-customer-order-nr-already-exists').modal({backdrop: 'static'});
					}
				});
		});

		// Set the order as an internal order for the employees
		$('[data-function="demo-order-handler"]').unbind('change.demo-order-handler').bind('change.demo-order-handler', function(){
			if($(this).is(':checked')){
				$('html').addClass('cursor-progress');

				$('#address_id').val(1);
				initSelect2($('#address_id'));

				let url = '/api/user/get-logged-user-info';
				axios.get(url)
					.then(function (response) {
						let user = response.data;

						//Remove disable class from containers
						$('.disabled').removeClass('disabled');

						$('#user_id').val(user.id).trigger('change');
						//$('#user_id').prop('disabled', true);

						$('[data-id="delivery_name"]').val(`${user.firstname} ${user.lastname}`);
						$('[data-id="delivery_name_2"]').val('');
						$('[data-id="delivery_name_3"]').val('');
						$('[data-id="delivery_street"]').val(user.street);
						$('[data-id="delivery_city"]').val(user.city);
						$('[data-id="delivery_zip"]').val(user.zip);
						$('[data-id="delivery_country_code"]').val(user.country_code);

						$('html').removeClass('cursor-progress');
					});
			}
		});

		// Change the shipment price when changing the shimpent method
		$('[data-function="shipping-price-handler"]').unbind('change.shipping-price-handler').bind('change.shipping-price-handler', function(){
			let shipping_method_id = $(this).val();
			let shipping_price = '';
			pageVar.address.shipping_methods.forEach(function(method){
				if(method.id == shipping_method_id){
					shipping_price = method.price;
					if(!shipping_price){
						shipping_price = 0;
					}
				}
			});

			$('[data-id="shipping_price"]').val(shipping_price);

			calcTotal();
		});

		// Create a new product row on button click
		addNewPrototype('add-new-prototype-product', () => addEditOrderHandler(false), () => calcTotal());
		// Create a new position row on button click
		addNewPrototype('add-new-prototype-position', () => addEditOrderHandler(false), () => calcTotal());

		// Remove the disable attr from the dispatch_date when the order is set to be sent in the future
		$('[data-function="future-order-handler"]').unbind('change.future-order-handler').bind('change.future-order-handler', function(){
			if($(this).is(':checked')){
				$('[data-id="dispatch_date"]').prop('disabled', false);
			}else{
				$('[data-id="dispatch_date"]').val('');
				$('[data-id="dispatch_date"]').prop('disabled', true);
			}
		});

		// Make the position list sortable
	    Sortable.create(sortable, {
	    	animation: 150,
	    	ghostClass: 'bg-info',
	    	handle: '.handle'
		});

		// Make the position list sortable
	    Sortable.create(sortable2, {
	    	animation: 150,
	    	ghostClass: 'bg-info',
	    	handle: '.handle'
		});

		// Disable submit button on form submit
		let allowSubmit = true;
		$('#order-form').submit(function(){
			if(allowSubmit){
				$('button[type="submit"]').addClass('disabled');

				allowSubmit = false;
			}else{
				return false;
			}
		});
	}

	initSelect2();
	initAutosize();


	//Calc the price of the order
	$('[data-function="amount-handler"], [data-id="shipping_price"]').unbind('keyup.amount-handler').bind('keyup.amount-handler', function(){
		calcTotal();
	});

	productPrototypeHandler();

	if(reload){
		getAddressInfo($('[data-function="address-handler"]').val(), (data) => {
			pageVar.address = data;
		});

		calcTotal();
	}
}

function addEditReturnHandler(reload = true){
	if(reload){
		pageVar.products = [];
		pageVar.order_data = [];

		// Create a new position row on button click
		addNewPrototype('add-new-prototype-product', () => {
			initSelect2($('[data-id="order_product_id"]'), pageVar.products);
			addEditReturnHandler(false)
		});

		// Load the orders of the selected address
		$('[data-function="address-handler"]').change(function(){
			let address_id = $(this).val();
			let url = '/api/return-orders/get-orders';
			if(address_id){
				url += '/'+address_id;
			}

			$('[data-id="order_id"]').prop('disabled', true);
			axios.get(url)
				.then(function (response) {
					//Fill the order list
					let orders = [];
					orders.push({id: '', text: "=== Bestellung auswählen ==="});
					response.data.forEach(order => orders.push({id: order.id, text: order.order_nr}));
					$('[data-id="order_id"]').prop('disabled', false);
					$('[data-id="order_id"]').empty();
					initSelect2($('[data-id="order_id"]'), orders);
				});
		});

		// Load the products of the selected address
		$('[data-function="order-handler"]').change(function(){
			let order_id = $(this).val();
			let url = '/api/return-orders/order-info/' + order_id;

			$('.prototype-container').find('.main-row:not(:first-of-type)').remove();

			axios.get(url)
				.then(function (response) {
					pageVar.order_data = response.data;
					$('[data-id="address_id"]').val(pageVar.order_data.address_id);
					initSelect2($('[data-id="address_id"]'));

					//Fill the product list
					pageVar.products = [];
					pageVar.products.push({id: '', text: "=== Produkt auswählen ==="});
					pageVar.order_data.products.forEach(product => pageVar.products.push({id: product.id, text: product.text}));
					$('[data-id="order_product_id"]').empty();
					initSelect2($('[data-id="order_product_id"]'), pageVar.products);


					$('.prototype-container').removeClass('disabled');
				});
		});

		// if it is in edit mode, load the data of the order
		if($('[data-function="order-handler"]').val()){
			let order_id = $('[data-function="order-handler"]').val();
			let url = '/api/return-orders/order-info/' + order_id;

			axios.get(url)
				.then(function (response) {
					pageVar.order_data = response.data;
					$('.prototype-container').removeClass('disabled');
					$('[data-id="amount"]').prop('disabled', false);
				});
		}
	}


	// Change the amount select when selecting a product
	$('[data-function="order-product-handler"]').change(function(){
		let row = $(this).parents('.main-row').eq(0);
		let order_product_id = $(this).val();

		let max = pageVar.order_data.amounts[order_product_id];

		let amount = row.find('[data-id="amount"]');
		amount.empty();

		for(let i = 1; i <= max; i++){
			amount.append(`<option value="${i}">${i}</option>`);
		}

		amount.prop('disabled', false);
	});
}

function addEditInvoiceHandler(reload = true){
	if(reload){
		// Save the current tab so that it opens again when saving
		formWithTabs(() => {
			if($('[role="tab"].active').prop('id') == 'invoice-info-tab'){
				$('.invoice-delete-btn').show();
			}else{
				$('.invoice-delete-btn').hide();
			}
		});

		// Check if the email is the main one or the software should change it when changing contact
		pageVar.syncEmail = true;
		pageVar.address = null;
		if($('[data-function="address-handler"]').val()){
			getAddressInfo($('[data-function="address-handler"]').val(), (data) => {
				pageVar.address = data;
				if(data.email_invoice === $('#Email').val()){
					pageVar.syncEmail = false;
				}
			});
		}

		/*
		 * Fill the contact list after selecting an address
		 * Fill the email field
		*/
		$('[data-function="address-handler"]').unbind('change.address-handler').bind('change.address-handler', function(){
			let value = $(this).val();
			getAddressInfo(value, (data) => {
				pageVar.address = data;
				//Fill the contact list
				let contacts = [];
				contacts.push({id: '', text: "=== Ansprechperson auswählen ==="});
				data.contacts.forEach(contact => contacts.push({id: contact.id, text: contact.full_name}));
				$('#contact').prop('disabled', false);
				$('#contact').empty();
				initSelect2($('#contact'), contacts);

				//Change the invoice email
				$('#Email').val('');
				if(data.email_invoice){
					$('#Email').val(data.email_invoice);
					pageVar.syncEmail = false;
				}/*else if(data.contacts[0].email){
					$('#Email').val(data.contacts[0].email);
					pageVar.syncEmail = true;
				}*/

				//Change the invoice reminders email
				$('#EmailReminders').val('');
				if(data.email_invoice_reminders){
					$('#EmailReminders').val(data.email_invoice_reminders);
				}
			});
		});

		/*
		 * Fill the email field
		*/
		$('[data-function="contact-handler"]').unbind('change.contact-handler').bind('change.contact-handler', function(){
			let value = $(this).val();
			if(pageVar.syncEmail && pageVar.address){
				let contact = pageVar.address.contacts.find(e => e.id == value);
				//$('#Email').val(contact.email);
			}
		});

		// Create a new position row on button click
		addNewPrototype('add-new-prototype-position', () => addEditInvoiceHandler(false));

		// Create a new payment row on button click
		addNewPrototype('add-new-prototype-payment', (uuid) => {
			$(`[data-prototype-container="payment-prototype"] [data-delete-target="payment-prototype${uuid}"] [disabled]`).attr('disabled', false);
			initDatepicker();
		});

		// Call the sendInvoice function in the invoice.els-elektronik.ch page
		$('[data-function="send-invoice"]').unbind('click.send-invoice').bind('click.send-invoice', function(){
			let url = $(this).data('url');
			if(url){
				$(this).parent().parent().hide();
				$('#modal-send-email').find('#modal-spinner').removeClass('d-none');

				axios.get(url)
					.then(function (response) {
						$('#modal-send-email').modal('hide');
						$('[data-toggle="modal"][data-target="#modal-send-email"]').parent().remove();
						setTimeout(function(){
							$('#modal-send-email').remove();
						}, 500);
						toastr.success('Die E-Mail wurde gesendet.');
					}).catch(error => {
						$('#modal-send-email').modal('hide');
						$('[data-toggle="modal"][data-target="#modal-send-email"]').remove();
						setTimeout(function(){
							$('#modal-send-email').remove();
						}, 500);
						toastr.error('Die E-Mail wurde nicht gesendet.');
					});
			}
		});
	}


	//Change the discount or the price of the product when the price or discount is changed
	$('[data-function="discount-handler"], [data-function="price-handler"], [data-function="price-total-handler"]').unbind('keyup.discount-price-handler').bind('keyup.discount-price-handler', function(){
		if($(this).data('function') == 'discount-handler' || $(this).data('function') == 'price-total-handler'){
			let discount = $(this).parents('.main-row').eq(0).find('[data-function="discount-handler"]').val();
			let priceInput = $(this).parents('.main-row').eq(0).find('[data-function="price-handler"]');
			let tarifPrice = $(this).parents('.main-row').eq(0).find('[data-function="price-total-handler"]').val();
			tarifPrice = reverseFormat(tarifPrice);

			let price = tarifPrice - ((discount * tarifPrice) / 100);
			price = bmRoundPrice(price);
			if(!isNaN(price)){
				price = formatNumber(price);
				priceInput.val(price);
			}
		}else{
			let price = reverseFormat($(this).val());
			let tarifPrice = $(this).parents('.main-row').eq(0).find('[data-function="price-total-handler"]').val();
			tarifPrice = reverseFormat(tarifPrice);
			let discountInput = $(this).parents('.main-row').eq(0).find('[data-function="discount-handler"]');

			let discount = 100 - ((price * 100) / tarifPrice);
			if(!tarifPrice){
				discount = 0;
			}

			if(!isNaN(discount)){
				discount = Math.round(discount * 100) / 100;
				discountInput.val(discount);
			}
		}


		//Calc the price of the invoice
		let net_price = 0;
		let vat_price = 0;
		$('[data-function="price-handler"]').each(function(){
			let price = reverseFormat($(this).val());
			let amount = $(this).parents('.row').eq(0).find('[data-function="amount-handler"]').val();

			if(amount == ''){
				amount = 1;
			}
			if(price != '' && !isNaN(price)){
				price = amount * price;
				net_price += price;

				let vat = parseFloat($(this).parents('.row').eq(0).find('[data-function="vat-handler"]').val());
				vat_price += (vat * price) / 100;
			}
		});

		net_price = bmRoundPrice(net_price);
		$('[data-id="total-net"]').html(formatNumber(net_price));

		vat_price = bmRoundPrice(vat_price);
		$('[data-id="total-vat"]').html(formatNumber(vat_price));

		let gross_price = net_price + vat_price;
		gross_price = bmRoundPrice(gross_price);
		$('[data-id="total-gross"]').html(formatNumber(gross_price));
	});


	initAutosize();

	// Make the position list sortable
    Sortable.create(sortable, {
    	animation: 150,
    	ghostClass: 'bg-info',
    	handle: '.handle'
	});


	if(reload){
		$('[data-function="price-handler"]').eq(0).trigger('keyup');
	}
}

function addEditSupplierHandler(){
	// Create a new contact row on button click
	addNewPrototype('add-new-prototype-contact', () => {
		initSelect2()
		initAutosize();
		initFormatPhoneNumber();
	});
}

function addEditUserHandler(){
	// When uploading an image, it shows it as a preview and fills the hidden field with the value
	$('[data-function="upload-image-handler"]').unbind('change.upload-image-handler').bind('change.upload-image-handler', function(){
		// Set the hidden field as true, so we know that an image was uploaded (image is saved in a session)
		$('#uploadSignatureData').val(1);

		// Show the image as a preview when uploaded
		if (this.files && this.files[0]) {
			var reader = new FileReader();

			reader.onload = function(e) {
				$('.image-preview-container').find('img').remove();
				$('.image-preview-container').prepend('<img class="img-fluid mb-4" src="'+e.target.result+'" alt="" />');


				$('.image-container').remove();
				$('.image-preview-container').removeClass('d-none');
			}

			// convert to base64 string
			reader.readAsDataURL(this.files[0]);
		}
	});

	// Manage the remove preview image button
	$('[data-function="remove-preview-image"]').unbind('click.remove-preview-image').bind('click.remove-preview-image', function(){
		// Set the hidden field as false, so we know that the uploaded image (saved in the session) has not to be uploaded
		$('#uploadSignatureData').val(0);

		$('.image-preview-container').addClass('d-none');
		$('.image-preview-container').find('img').remove();
	});

	// Set the delete image modal as ajax
	modalAjaxForm(
		$('#modal-delete-image'),
		(data) => {
			if(data.success){
				$('.image-container').remove();
				$('.image-upload-field-container').removeClass('d-none');
				toastr.success('Bild wurde entfernt.');
			}else{
				toastr.error('Bild wurde nicht entfernt.');
			}
		}
	);
}

function addEditDemoProductHandler(reload = true){
	const productUsers = $('[data-product-user]').data('productUser');
	if(reload){

		// Create a new contact row on button click
		addNewPrototype('add-new-prototype-demo-product', (uuid) => {
			let user = $('[data-id="owner_id"]').val();

			let select = $(`[data-delete-target="demo-product-prototype${uuid}"]`).find('[data-id="demo_product_id"]');
			select.empty();

			let demoProducts = [];
			demoProducts.push({id: '', text: "=== Produkt auswählen ==="});

			if(productUsers[user]){
				Object.keys(productUsers[user]).forEach((id) => demoProducts.push({id: id, text: productUsers[user][id]['description']}));
			}

			initSelect2(select, demoProducts);

			addEditDemoProductHandler(false);
		});


		// Change product list when changing the user
		$('[data-id="owner_id"]').change(function(){
			$('[data-prototype-container="demo-product-prototype"] .main-row').remove();

			$('[data-function="add-new-prototype-demo-product"]').eq(0).click();
		});


		//Empty the address or user field when changing one of this two. Only an address or a user can be selected
		$('[data-id="address_id"], [data-id="user_id"]').change(function(){
			if($(this).data('id') == 'address_id'){
				$('[data-id="user_id"]').val('');
				initSelect2($('[data-id="user_id"]'));
			}else{
				$('[data-id="address_id"]').val('');
				initSelect2($('[data-id="address_id"]'));
			}
		});
	}

	// Change the pieces select option when changin the selected product
	$('[data-id="demo_product_id"]').unbind('change.demo-product-handler').bind('change.demo-product-handler', function(){
		let demoProduct = $(this).val();
		let user = $('[data-id="owner_id"]').val();

		let piecesEl = $(this).parents('.main-row').find('[data-id="pieces"]');
		piecesEl.empty();

		let pieces = productUsers[user][demoProduct]['pieces'];
		for(let i = 1; i <= pieces; i++){
			piecesEl.append(`<option value="${i}">${i}</option>`);
		}
	});
}

function addEditReportHandler(initAllFn = true){
	// manages the address select.
	$('[data-function="address-handler"]').unbind('change.address-handler').bind('change.address-handler', function(){
		const reportingPersonEl = $('[data-id="reporting_person"]');
		const operatorPersonEl = $('[data-id="operator_person"]');

		// Empty fields
		$('[data-id="address_email"]').val('');
		$('[data-id="reporting_person_email"]').val('');
		$('[data-id="reporting_person_phone"]').val('');
		$('[data-id="operator_person_email"]').val('');
		$('[data-id="operator_person_phone"]').val('');

		// Keep all linked text fields editable, also when the customer is entered manually.
		$('.disabled').removeClass('disabled');
		reportingPersonEl.prop('disabled', false);
		operatorPersonEl.prop('disabled', false);
		$('[data-id="address_email"], [data-id="reporting_person_email"], [data-id="reporting_person_phone"], [data-id="operator_person_email"], [data-id="operator_person_phone"]').prop('disabled', false);

		let value = $(this).val();
		if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
			pageVar.address = null;
			const contacts = [{id: '', text: "=== auswählen ==="}];
			updateOptionsSelect2(reportingPersonEl, contacts);
			updateOptionsSelect2(operatorPersonEl, contacts);
			return;
		}

		getAddressInfo(value, (data) => {
			pageVar.address = data;

			// Fill address email field
			$('[data-id="address_email"]').val(data.email_security);

			//Fill the contact list
			let contacts = [];
			contacts.push({id: '', text: "=== auswählen ==="});
			data.contacts.forEach(contact => contacts.push({id: contact.full_name, text: contact.full_name}));
			updateOptionsSelect2(reportingPersonEl, contacts);
			updateOptionsSelect2(operatorPersonEl, contacts);

			reportingPersonEl.unbind('change.contact-handler').bind('change.contact-handler', function(){
				data.contacts.filter((contact) => {
				    if(contact.full_name == $(this).val()){
				    	// Fill reporting person email field
						$('[data-id="reporting_person_email"]').val(contact.email);

						// Fill reporting person phone field
						$('[data-id="reporting_person_phone"]').val(contact.phone);
				    }
				});
			});
			operatorPersonEl.unbind('change.contact-handler').bind('change.contact-handler', function(){
				data.contacts.filter((contact) => {
				    if(contact.full_name == $(this).val()){
				    	// Fill reporting person email field
						$('[data-id="operator_person_email"]').val(contact.email);

						// Fill reporting person phone field
						$('[data-id="operator_person_phone"]').val(contact.phone);
				    }
				});
			});
		});
	});

	// manages the User select.
	$('[data-function="user-handler"]').unbind('change.user-handler').bind('change.user-handler', function(){
		// Empty fields
		$('[data-id="user_email"]').val('');
		$('[data-id="user_phone"]').val('');

		let value = $(this).val();
		getUserInfo(value, (data) => {
			if(data.id){
				$('[data-id="user_email"]').val(data.email);
				$('[data-id="user_phone"]').val(data.phone);
			}
		});
	});

	// manages the PRRC clinics select.
	$('[data-function="supplier-handler"]').unbind('change.supplier-handler').bind('change.supplier-handler', function(){
		// Empty fields
		$('[data-id="supplier_email"]').val('');
		$('[data-id="prrc_clinic_email"]').val('');
		$('[data-id="prrc_clinic_phone"]').val('');
		$('[data-id="supplier_ch_rep"]').val('');
		$('[data-id="supplier_ch_rep_number"]').val('');
		const linkedSupplierFields = $('[data-id="supplier_email"], [data-id="prrc_clinic_email"], [data-id="prrc_clinic_phone"], [data-id="supplier_ch_rep"], [data-id="supplier_ch_rep_number"]');
		linkedSupplierFields.prop('disabled', false);

		let value = $(this).val();
		if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
			return;
		}

		getPrrcInfo(value, (data) => {
			if(data.id){
				$('[data-id="supplier_email"]').val(data.email_security);
				$('[data-id="prrc_clinic_email"]').val(data.important_contact_email);
				$('[data-id="prrc_clinic_phone"]').val(data.important_contact_phone);
				$('[data-id="supplier_ch_rep"]').val(data.ch_rep);
				$('[data-id="supplier_ch_rep_number"]').val(data.ch_rep_number);
			}
		});
	});

	// Manages injuries select
	$('[data-function="injuries-handler"]').unbind('change.injuries-handler').bind('change.injuries-handler', function(){
		let val = $(this).val();
		if(val == 'yes'){
			$('[data-id="injuries_remarks"]').parents('.form-group').eq(0).removeClass('d-none');
		}else{
			$('[data-id="injuries_remarks"]').parents('.form-group').eq(0).addClass('d-none');
		}
	});

	// Manages serious_incident_according_to_ch_rep select
	$('[data-function="serious_incident_according_to_ch_rep-handler"]').unbind('change.serious_incident_according_to_ch_rep-handler').bind('change.serious_incident_according_to_ch_rep-handler', function(){
		let val = $(this).val();
		if(val == 'yes' || val == 'no'){
			$('[data-id="serious_incident_according_to_ch_rep_why"]').parents('.form-group').eq(0).removeClass('d-none');
		}else{
			$('[data-id="serious_incident_according_to_ch_rep_why"]').parents('.form-group').eq(0).addClass('d-none');
		}
	});

	// Manages swissmedic_declaration select
	$('[data-function="swissmedic_declaration-handler"]').unbind('change.swissmedic_declaration-handler').bind('change.swissmedic_declaration-handler', function(){
		let val = $(this).val();
		if(val == 'yes'){
			$('[data-id="swissmedic_declaration_received_at"]').parents('.form-group').eq(0).removeClass('d-none');
		}else{
			$('[data-id="swissmedic_declaration_received_at"]').parents('.form-group').eq(0).addClass('d-none');
		}
	});

	// Create a new product row on button click
	const newProductCallback = () => {
		initSelect2();

		// Search for batch lot and serial number of a product
		$('[data-function="product-handler"]').unbind('change.product-handler').on('change.product-handler', function () {
			let row = $(this).parents('.row').eq(0);
			let value = $(this).val();
			let address = $("#address_id").val();

			if(address === null || address === undefined || !/^\d+$/.test(address.toString())){
				return;
			}

			if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
				return;
			}

			axios.get(
				`/api/product/${value}/get-info-for-report?address_id=${address}`)
				.then(function (response) {
					let data = response.data;
					if(data != ""){
						if(data.supplier_id){
							$('[data-id="supplier"]').val(data.supplier_id);
							$('[data-id="supplier"]').trigger('change');
						}

						let batchLots = [];
						batchLots.push({id: '', text: "=== auswählen ==="});
						Object.keys(data.batch_lots).forEach(batch_lot => batchLots.push({id: batch_lot, text: batch_lot}));
						updateOptionsSelect2(row.find('[data-id="batch_lot"]'), batchLots);

						let serialNumbers = [];
						serialNumbers.push({id: '', text: "=== auswählen ==="});
						Object.keys(data.serial_numbers).forEach(serial_number => serialNumbers.push({id: serial_number, text: serial_number}));
						updateOptionsSelect2(row.find('[data-id="serial_number"]'), serialNumbers);
					}
				});
		});

		// Manage available_for_analysis select
		$('[data-function="available_for_analysis-handler"]').unbind('change.available_for_analysis-handler').bind('change.available_for_analysis-handler', function(){
			let val = $(this).val();
			if(val == 'yes'){
				$(this).parents('.row').eq(0).find('[data-id="is_contaminated"]').parents('.form-group').eq(0).removeClass('d-none');
			}else{
				$(this).parents('.row').eq(0).find('[data-id="is_contaminated"]').parents('.form-group').eq(0).addClass('d-none');
			}
		});

	}
	addNewPrototype('add-new-prototype-product', () => newProductCallback());


	// Create a new activity row on button click
	$('[data-function="add-new-prototype-activity"]').unbind('click.add-new-prototype').bind('click.add-new-prototype', function(){
		let btn = $(this);
		let target = $(this).data('target');
		let type = $(this).data('type');
		let text = $(this).data('text');

		// Remove btn
		if(type != 'other'){
			$(`[data-function="add-new-prototype-activity"][data-type="${type}"]`).next().remove(); // Removes the dropdown-divider
			$(`[data-function="add-new-prototype-activity"][data-type="${type}"]`).remove();
		}

		//Remove "no record" container
		$(`[data-prototype-container="${target}"]`).find('.no-records').remove();

		//Create unique id
		var uuid = parseInt(Math.random() * Math.floor(9899) + 100);

		// Add prototype
		var prototype = $(`[data-prototype-name="${target}"]`).data('prototype-html').replace(/__NAME__/g, uuid);
		$(`[data-prototype-name="${target}"]`).before(prototype);

		let container = $(`[data-prototype-name="${target}"]`).prev();

		// Add text
		container.find('[data-id="type"]').val(type);
		container.find('[data-id="info_text"]').html(text);


		// Init functions
		initAutosize();
		initDatepicker();

		removePrototype();

		// Focus first input field
		let input = container.find('input[type="text"], select, textarea').eq(0);
		input.focus();
	});
}
